import { render, staticRenderFns } from "./TheProductTypesUpdate.vue?vue&type=template&id=ea14630e"
import script from "./TheProductTypesUpdate.vue?vue&type=script&lang=js"
export * from "./TheProductTypesUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports